var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_115_2029)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 13,
    fill: "url(#paint0_linear_115_2029)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0497 17.5296C18.1419 17.3905 18.267 17.2751 18.4145 17.1932C18.5619 17.1112 18.7274 17.0652 18.8968 17.0588H36.116C36.116 17.0588 36.1603 17.0967 36.1825 17.0967L40.0582 14.1857C39.5224 13.7121 38.8953 13.3475 38.2137 13.1134C37.5321 12.8793 36.8096 12.7803 36.0884 12.8222H18.8692C15.7188 12.8222 13.0667 14.9378 13.0667 18.0815V21.7716L18.0497 17.5296ZM36.9687 23.9684L36.8746 35.2607V38.3394L34.7208 36.2671H18.8692C18.3155 36.2671 18.2823 35.8018 18.2823 35.2607V23.1568L13.0667 23.8385V35.2607C13.0667 38.4043 15.7243 40.4983 18.8692 40.4983H32.949L41.8576 48.5333L41.7414 18.6712L36.9687 23.9684Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0667 25.1588L18.0497 29.5956V23.1027L13.0667 23.7628V25.1588Z",
    fill: "#605958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4179 33.9252L13.0667 23.872L17.2912 20.2197L27.5618 27.4594L45.7333 11.2L27.4179 33.9252Z",
    fill: "#FF3214"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_115_2029",
    x1: 56,
    y1: 56,
    x2: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F3",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115_2029"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 13,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4acb9305100fe64bb433d0f2f81a0742.svg";
export { ForwardRef as ReactComponent };